import AppDialog from '../dialog/AppDialog';
import { mapGetters } from 'vuex';
import utils from 'Helpers/utils';
import store from '~/store';
import CornerFlag from 'Pages/core/icon/corner/CornerFlag.vue';
import SoccerBall from 'Pages/core/icon/ball/SoccerBall.vue';
import Constants from 'Helpers/constants';

export default {
    name: 'app-grid',
    components: {
        SoccerBall,
        CornerFlag,
        AppDialog,
    },
    requiredDictionaries: ['BetType', 'BotBetType', 'BetStatus', 'BetSelection', 'BotFavoriteSide', 'Site', 'OrderSite', 'CurrencyAll', 'TimeZone'],
    requiredData: ['Stats'],
    props: {
        width: {
            default: 600,
            type: Number,
        },
        title: {
            default: '',
            type: String,
        },
        // feedLine: {
        //     default: undefined,
        //     type: Object,
        // },
    },
    data() {
        return {
            tab: 0,
            loading: false,
            // headers: Headers,
            // headersBets: HeadersBets,
            feedLine: undefined,
            balance: 0,
            periodTypeId: undefined,
            options: {
                page: 1,
                // itemsPerPage: 100,
                sortBy: ['created_at'],
                sortDesc: [false],
                // rowsPerPageItems: [50, 100, 200, 400],
            },
            balances: [],
            cornersBalances: [],
            listDisabled: true,
            listCornersDisabled: true,
        };
    },

    mounted() {
        console.log('Component %s mounted.', this.$options.name);
    },

    methods: {
        cancel(success) {
            success();

            this.listBets = [];
            this.balances = [];
            this.cornersBalances = [];
        },
        loadData() {
            this.loading = true;
            let params = {
                options: this.options,
                filters: {
                    period_type_id: this.periodTypeId,
                    custom_event_id: this.feedLine.ceId,
                },
                requiredDictionaries: this.$options.requiredDictionaries,
                requiredData: this.$options.requiredData,
            };

            this.$store.dispatch('BetModule/list', params).then((response) => {
                this.loading = false;

                if (response.data.success !== false) {
                    let rows = response.data.rows.filter((row) => row.order_bet_type_id !== 7 && row.order_bet_type_id !== 8);
                    this.list = rows;
                    this.listDisabled = rows.length === 0;

                    rows = response.data.rows.filter((row) => row.order_bet_type_id === 7 || row.order_bet_type_id === 8);
                    this.listCorners = rows;
                    this.listCornersDisabled = rows.length === 0;

                    this.tab = this.listDisabled ? 1 : 0;
                }
            });
        },
        getStatusName: function (status_id) {
            let betStatuses = this.getBetStatusDictionary;
            let result = status_id ? betStatuses.filter((betStatus) => betStatus.id === status_id) : null;

            return result ? result[0].name : null;
        },
        getBotBetTypeName: function (item) {
            let result = '';
            let betTypes = this.getBotBetTypeDictionary;
            if (item.type === this.$const.BET_TYPE_HANDICAP_DOG || item.type === this.$const.BET_TYPE_HANDICAP_JOLLY) {
                result = item.teamwhere === 1 ? this.$t('bet.home') : this.$t('bet.away');
                result += ' ';
            } else if (item.type === this.$const.BET_TYPE_CORNERS_HANDICAP_DOG || item.type === this.$const.BET_TYPE_CORNERS_HANDICAP_JOLLY) {
                result = item.teamwhere === 1 ? this.$t('bet.cornersHome') : this.$t('bet.cornersAway');
                result += ' ';
            } else if (item.type === this.$const.BET_TYPE_BTTS_YES) {
                result = this.$t('bet.bts') + ' - ' + this.$t('bet.yes') + ' ';
            } else if (item.type === this.$const.BET_TYPE_BTTS_NO) {
                result = this.$t('bet.bts') + ' - ' + this.$t('bet.no') + ' ';
            } else if (item.type === this.$const.BET_TYPE_DC_HOME_OR_DRAW) {
                result = this.$t('betDialog.home') + this.$t('betDialog.or') + this.$t('betDialog.draw') + ' ';
            } else if (item.type === this.$const.BET_TYPE_DC_HOME_OR_AWAY) {
                result = this.$t('betDialog.home') + this.$t('betDialog.or') + this.$t('betDialog.away') + ' ';
            } else if (item.type === this.$const.BET_TYPE_DC_DRAW_OR_AWAY) {
                result = this.$t('betDialog.draw') + this.$t('betDialog.or') + this.$t('betDialog.away') + ' ';
            } else if (item.type === this.$const.BET_TYPE_CS_CS) {
                result = this.$t('betDialog.correctScore') + ' ' + item.correct_score;
            } else {
                result = item.type ? betTypes.filter((betType) => betType.id === item.type) : null;
                result = result ? result[0].name + ' ' : null;
            }

            if ((item.type === this.$const.BET_TYPE_HANDICAP_DOG || item.type === this.$const.BET_TYPE_CORNERS_HANDICAP_DOG) && item.handicap > 0) {
                result += '+';
            }

            if (
                item.type !== this.$const.BET_TYPE_1X2_DRAW &&
                item.type !== this.$const.BET_TYPE_1X2_AWAY &&
                item.type !== this.$const.BET_TYPE_1X2_HOME &&
                item.type !== this.$const.BET_TYPE_BTTS_YES &&
                item.type !== this.$const.BET_TYPE_BTTS_NO &&
                item.type !== this.$const.BET_TYPE_DC_HOME_OR_DRAW &&
                item.type !== this.$const.BET_TYPE_DC_HOME_OR_AWAY &&
                item.type !== this.$const.BET_TYPE_DC_DRAW_OR_AWAY &&
                item.type !== this.$const.BET_TYPE_CS_CS
            ) {
                if (item.handicap == 0) {
                    result += 0;
                } else {
                    result += parseFloat(item.handicap).toFixed(2);
                }
            }

            return result;
        },

        goalClass(goal) {
            return this.feedLine.sc && goal == this.feedLine.sc.split('-')[0]
                ? 'bold greyBg text-center br'
                : this.feedLine.sc && goal <= this.feedLine.sc.split('-')[0]
                ? 'greyBg text-center br'
                : 'text-center br';
        },

        cornersClass(corners) {
            return corners == this.cornersHome ? 'bold greyBg text-center br' : corners <= this.cornersHome ? 'greyBg text-center br' : 'text-center br';
        },

        headClass(head) {
            return this.feedLine.sc && parseInt(head.text) <= parseInt(this.feedLine.sc.split('-')[1]) ? 'text-center greyBg' : 'text-center';
        },

        cornersHeadClass(head) {
            const start = this.cornersAway;

            return parseInt(head.text) + parseInt(start) <= this.cornersAway ? 'text-center greyBg' : 'text-center';
        },

        expected(bet, score, cornersHome, cornersAway) {
            let balance;
            let betScore;

            if (bet.balance) {
                balance = bet.balance;
            } else {
                if (this.feedLine.mId !== Constants.DBALL_MARKET_LIVE) {
                    score = '0-0';
                    betScore = '0-0';
                } else {
                    //Corners bets
                    if (
                        bet.type === Constants.BET_TYPE_CORNERS_HANDICAP_JOLLY ||
                        bet.type === Constants.BET_TYPE_CORNERS_HANDICAP_DOG ||
                        bet.type === Constants.BET_TYPE_CORNERS_GOAL_OVER ||
                        bet.type === Constants.BET_TYPE_CORNERS_GOAL_UNDER
                    ) {
                        score = utils.isValidNumber(cornersHome) ? cornersHome + '-' + cornersAway : null;
                        betScore = utils.isValidNumber(bet.corners_home) ? bet.corners_home + '-' + bet.corners_away : null;
                    } else {
                        //Regular bets
                        if (bet.period_type_id == Constants.GAME_PERIOD_FT || this.feedLine.time.includes('1H')) {
                            score = this.feedLine.sc;
                        } else if ('score_ir_ht' in bet) {
                            // if there is no balance in 1h bet and game is not in 1H then we received this bet after reload feed and need to use score_ir_ht score
                            score = bet.score_ir_ht;
                        }

                        betScore = bet.score;
                    }

                    if (bet.is_live === 0) {
                        betScore = '0-0';
                    }

                    if (!score || !betScore) {
                        return '<span>N/A</span>';
                    }
                }

                let balanceCalculated = utils.wlCalculate(bet.type, bet.teamwhere, score, betScore, bet.correct_score, bet.handicap, bet.odds, bet.stake, null);

                balance = balanceCalculated['balance'];
            }

            let cls = balance == 0 ? 'yellowText' : balance > 0 ? 'greenText' : 'redText';

            return '<span class="' + cls + '">' + parseFloat(balance).toFixed(2) + '</span>';
        },

        cornersHeaders(head) {
            if (head.value === 'goal') {
                return head.text;
            }

            const start = this.cornersAway !== null ? this.cornersAway : 0;

            return parseInt(head.text) + parseInt(start);
        },
    },
    computed: {
        ...mapGetters({
            getBetStatusDictionary: 'DictionariesModule/getBetStatusDictionary',
            getBotBetTypeDictionary: 'DictionariesModule/getBotBetTypeDictionary',
            // getTotal: 'PageModule/getTotal',
        }),
        list: {
            get() {
                return this.balances;
            },
            set(value) {
                let data = [];
                for (let i = 0; i <= 10; i++) {
                    data.push({});
                    for (let j = 0; j <= 10; j++) {
                        if (j === 0) {
                            data[i]['goal'] = i;
                        }

                        let k = 'balance_' + j;
                        let totalBalance = 0;
                        let score = i + '-' + j;

                        value.forEach((bet) => {
                            if (
                                bet.status_id == this.$const.BET_STATUS_REJ ||
                                bet.status_id == this.$const.BET_STATUS_ABN ||
                                bet.status_id == this.$const.BET_STATUS_VOID ||
                                !bet.score //if the score isn't confirmed for a bet
                            ) {
                                //need to skip these bets
                                return;
                            }

                            let balance = utils.wlCalculate(
                                bet.type,
                                bet.teamwhere,
                                score,
                                bet.score,
                                bet.correct_score,
                                bet.handicap,
                                bet.odds,
                                bet.stake,
                                null
                            );
                            totalBalance += balance['balance'];
                        });

                        data[i][k] = parseFloat(totalBalance).toFixed(2);
                    }
                }
                this.balances = data;
            },
        },
        cornersHome() {
            if (this.feedLine.mId !== Constants.DBALL_MARKET_LIVE) {
                return 0
            }
            return utils.isValidNumber(this.feedLine.cHome) ? this.feedLine.cHome : null;
        },
        cornersAway() {
            if (this.feedLine.mId !== Constants.DBALL_MARKET_LIVE) {
                return 0
            }
            return utils.isValidNumber(this.feedLine.cAway) ? this.feedLine.cAway : null;
        },
        cornersSum() {
            return this.cornersHome !== null ? this.cornersHome + this.cornersAway : null;
        },
        listCorners: {
            get() {
                return this.cornersBalances;
            },
            set(value) {
                let data = [];

                for (let i = 0; i <= 10; i++) {
                    data.push({});
                    for (let j = 0; j <= 10; j++) {
                        if (j === 0) {
                            data[i]['corners_home'] = i + this.cornersHome;
                        }

                        let k = 'balance_' + j;

                        data[i][j] = { corners_away: j + this.cornersAway };
                        data[i][j]['corners_sum'] = parseInt(data[i]['corners_home']) + parseInt(data[i][j]['corners_away']);

                        let totalBalance = 0;

                        const cornersHome = i + this.cornersHome;
                        const cornersAway = j + this.cornersAway;

                        let score = cornersHome + '-' + cornersAway;

                        value.forEach((bet) => {
                            if (
                                bet.status_id == this.$const.BET_STATUS_REJ ||
                                bet.status_id == this.$const.BET_STATUS_ABN ||
                                bet.status_id == this.$const.BET_STATUS_VOID
                            ) {
                                //need to skip these bets
                                return;
                            }
                            let betScore;

                            if (bet.is_live === 0) {
                                betScore = '0-0';
                            } else {
                                betScore = utils.isValidNumber(bet.corners_home) ? bet.corners_home + '-' + bet.corners_away : null;
                            }

                            //corners aren't confirmed for a bet
                            if (!betScore) {
                                //need to skip these bets
                                return;
                            }

                            let balance = utils.wlCalculate(
                                bet.type,
                                bet.teamwhere,
                                score,
                                betScore,
                                bet.correct_score,
                                bet.handicap,
                                bet.odds,
                                bet.stake,
                                null
                            );
                            totalBalance += balance['balance'];
                        });

                        data[i][k] = parseFloat(totalBalance).toFixed(2);
                    }
                }
                this.cornersBalances = data;
            },
        },
        listBets: {
            get() {
                return this.$store.getters['BetModule/getList'];
            },
            set(value) {
                this.$store.commit('BetModule/setList', value);
            },
        },
        stats: {
            get() {
                return this.$store.getters['BetModule/getStats'];
            },
            set(value) {
                this.$store.commit('BetModule/setStats', value);
            },
        },
        user() {
            return this.$store.getters['UserModule/getUser'];
        },
        gridTitle() {
            return this.title === '' ? store.$i18n.t('gameGrid.title') : this.title;
        },
        headers() {
            return [
                {
                    text: store.$i18n.t('gameGrid.goal'),
                    value: 'goal',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '0',
                    value: 'balance_0',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '1',
                    value: 'balance_1',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '2',
                    value: 'balance_2',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '3',
                    value: 'balance_3',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '4',
                    value: 'balance_4',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '5',
                    value: 'balance_5',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '6',
                    value: 'balance_6',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '7',
                    value: 'balance_7',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '8',
                    value: 'balance_8',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '9',
                    value: 'balance_9',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '10',
                    value: 'balance_10',
                    align: 'center',
                    sortable: false,
                },
            ];
        },
        headersCorners() {
            return [
                {
                    text: store.$i18n.t('gameGrid.corners'),
                    value: 'goal',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '0',
                    value: 'balance_0',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '1',
                    value: 'balance_1',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '2',
                    value: 'balance_2',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '3',
                    value: 'balance_3',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '4',
                    value: 'balance_4',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '5',
                    value: 'balance_5',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '6',
                    value: 'balance_6',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '7',
                    value: 'balance_7',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '8',
                    value: 'balance_8',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '9',
                    value: 'balance_9',
                    align: 'center',
                    cellClass: 'br',
                    sortable: false,
                },
                {
                    text: '10',
                    value: 'balance_10',
                    align: 'center',
                    sortable: false,
                },
            ];
        },
        headersBets() {
            return [
                {
                    text: store.$i18n.t('bet.date'),
                    value: 'created_at',
                    align: 'left',
                    sortable: false,
                    width: 60,
                },
                {
                    text: store.$i18n.t('bet.bot') + '/' + store.$i18n.t('bet.order'),
                    value: 'bot_name',
                    align: 'left',
                    sortable: false,
                    width: 190,
                },
                {
                    text: store.$i18n.t('bet.bookmaker'),
                    value: 'site_id',
                    align: 'left',
                    sortable: false,
                    width: 50,
                },
                {
                    text: store.$i18n.t('bet.status'),
                    value: 'status_id',
                    align: 'left',
                    sortable: false,
                    width: 60,
                },
                {
                    text: store.$i18n.t('bet.bet'),
                    sortable: false,
                    align: 'left',
                    value: 'type',
                    width: 130,
                },
                {
                    text: store.$i18n.t('bet.odds'),
                    sortable: false,
                    align: 'center',
                    value: 'odds',
                    width: 40,
                },
                {
                    text: '',
                    sortable: false,
                    align: 'center',
                    value: 'score',
                    width: 55,
                },
                {
                    text: store.$i18n.t('bet.min'),
                    sortable: false,
                    align: 'center',
                    value: 'minute',
                    width: 35,
                },
                {
                    text: store.$i18n.t('bet.stake'),
                    sortable: false,
                    align: 'right',
                    value: 'stake',
                    width: 40,
                },
                {
                    text: store.$i18n.t('gameGrid.expected'),
                    sortable: false,
                    align: 'right',
                    value: 'expected',
                    width: 40,
                },
            ];
        },
    },
};
